import { render, staticRenderFns } from "./BeautyEpilationDataSheet.vue?vue&type=template&id=2ee75aa8&scoped=true"
import script from "./BeautyEpilationDataSheet.vue?vue&type=script&lang=js"
export * from "./BeautyEpilationDataSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee75aa8",
  null
  
)

export default component.exports